import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitBottomRight24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowFitBottomRight24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.467 3.75a.75.75 0 0 0-.75-.75H3v8.716h.75H3a.75.75 0 0 0 1.5 0h-.75.75V5.56l13.928 13.93a1 1 0 0 1-.175.012H8.298a.75.75 0 0 0 0 1.5h9.955a2.75 2.75 0 0 0 2.748-2.75V8.298a.75.75 0 1 0-1.5 0v9.953q0 .09-.012.178L5.559 4.5h6.158a.75.75 0 0 0 .75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitBottomRight24);
